module.exports = __webpack_public_path__ + "img/Home_Desktop_02.b359850b.jpg";